export default function CsharpBitwiseOperators() {
  return (
    <h2>Csharp Bitwise Operators</h2>
  );
}
